module.exports = __webpack_public_path__ + "static/media/style-1.2bef3a68.svg";